import { api } from "./api";

export class Utils {

    public static logMessage(comment: string): void {
        // const rawStack = new Error().stack
        //     ?.split('\n')
        //     .slice(2)
        //     .map(l => l.trim());

        // const message = comment + '\n' + rawStack?.join('\n');
        api<void>('addLog', {
            message: comment ?? ''
        });
    }

    public static minify(input: string): string {

        const protectedBlocks: Record<string, string> = {};
        let counter = 0;

        // 1. Skydda <pre>, <code>, <script>, <style>
        const protect = (tag: string) => {
            const regex = new RegExp(`<${tag}[^>]*>[\\s\\S]*?<\\/${tag}>`, 'gi');
            input = input.replace(regex, block => {
                const key = `__BLOCK_${counter++}__`;
                protectedBlocks[key] = block;
                return key;
            });
        };

        ['pre', 'code', 'script', 'style'].forEach(protect);

        // 2. Ta bort HTML-kommentarer
        input = input.replace(/<!--[\s\S]*?-->/g, '');

        // 3. Komprimera whitespace mellan taggar
        input = input
            .replace(/\n+/g, ' ')       // ta bort radbrytningar
            .replace(/\s{2,}/g, ' ')    // komprimera multipla spaces
            .replace(/\s*</g, '<')      // trimma före <
            .replace(/>\s*/g, '>');     // trimma efter >

        // 4. Återställ skyddade block
        for (const key in protectedBlocks) {
            input = input.replace(key, protectedBlocks[key]);
        }

        return input.trim();
    }

    public static overlay(show: boolean): void {
        if (show) {
            const element = document.createElement('div');
            element.className = 'overlay';
            document.body.appendChild(element);
        }
        else {
            const element = document.body.querySelector('.overlay');
            if (element) document.body.removeChild(element);
        }
    }

    public static forceRefresh(element: HTMLElement): void {
        const temp = element.innerHTML;
        element.innerHTML = temp;
    }

    public static replaceElement(oldElement: HTMLElement, newElement: HTMLElement): void {

        if (typeof oldElement.replaceWith === "function") {
            oldElement.replaceWith(newElement);
        } else if (oldElement.parentNode) {
            oldElement.parentNode.replaceChild(newElement, oldElement);
        }
        Utils.forceRefresh(newElement);
    }



    public static toggleCss(element: HTMLElement, tag: string): void {
        if (element) {
            if (element.classList.contains(tag)) {
                element.classList.remove(tag);
            } else {
                element.classList.add(tag);
            }
        }
    }

    public static stripHost(url: string): string {
        try {
            return new URL(url).pathname;
        } catch {
            return url;
        }
    }

    // Utility function to calculate scaled dimensions
    public static scaleImageToFit(
        img: HTMLImageElement,
        containerWidth: number,
        containerHeight: number): { width: number; height: number } {

        const imgRatio = img.naturalWidth / img.naturalHeight;
        const containerRatio = containerWidth / containerHeight;

        let width: number;
        let height: number;

        if (containerRatio > imgRatio) {
            // Container is wider than image ratio → match height
            height = containerHeight;
            width = height * imgRatio;
        } else {
            // Container is taller than image ratio → match width
            width = containerWidth;
            height = width / imgRatio;
        }

        return { width, height };
    }

    public static autoScaleImage(img: HTMLImageElement, container: HTMLElement) {

        if (!img || !container) {
            console.error("Image or container not found.");
            return;
        }

        // Ensure image is loaded before scaling
        const onImageLoad = () => {
            const resizeObserver = new ResizeObserver(() => {
                const { width, height } = Utils.scaleImageToFit(
                    img,
                    container.clientWidth,
                    container.clientHeight
                );
                img.style.width = `${width}px`;
                img.style.height = `${height}px`;
                img.style.position = "absolute";
                img.style.left = `${(container.clientWidth - width) / 2}px`;
                img.style.top = `${(container.clientHeight - height) / 2}px`;
            });

            resizeObserver.observe(container);
        };

        if (img.complete) {
            onImageLoad();
        } else {
            img.onload = onImageLoad;
        }
    }

    public static splitTextIntoRows(text: string): string[] {
    if (typeof text !== "string") {
        throw new Error("Input must be a string");
    }

    // Normalize line endings to \n and split
    const rows = text
        .replace(/\r\n/g, "\n") // Handle Windows line endings
        .split("\n")            // Split into rows
        .map(row => row.trim()) // Remove extra spaces
        .filter(row => row.length > 0); // Remove empty lines

        return rows;
    }

}